"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffluentPond = void 0;
const Pond_1 = require("./Pond");
const typeName = 'EffluentPond';
class EffluentPond extends Pond_1.Pond {
    constructor(ob) {
        var _a;
        super({ ...ob, type: (_a = ob.type) !== null && _a !== void 0 ? _a : typeName });
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
        };
    }
}
exports.EffluentPond = EffluentPond;
